/*
 * pack-visibilite — page produit « Pack Visibilité » (TikTok / Instagram)
 * ----------------------------------------------------------------------
 * Offre (variante) + fréquence (selling plan Recharge) + nom d'utilisateur
 * + vidéos choisies → propriétés de la ligne de commande.
 *
 * Les quantités viennent des métachamps de variante, injectés en JSON par
 * snippets/pack-visibilite.liquid. La répartition par vidéo est faite ici :
 * parts égales, le reste de la division sur la première vidéo choisie.
 *
 * Propriétés envoyées (lisibles par la supply, toujours en français) :
 *   Plateforme, Nom d'utilisateur, Vidéo 1 … Vidéo N, _Total pack (cachée).
 *
 * L'envoi passe par le <product-form> du thème (tiroir panier, erreurs).
 * Le bouton reste désactivé tant qu'il manque le compte ou une vidéo, et un
 * garde en phase de capture bloque toute soumission incomplète.
 */
(function () {
  'use strict';

  var STATS = [
    { key: 'views', label: 'vues' },
    { key: 'likes', label: 'likes' },
    { key: 'shares', label: 'partages' },
    { key: 'saves', label: 'enregistrements' }
  ];
  var HANDLE_RE = /^[a-z0-9._]{1,30}$/;
  var REQUEST_TIMEOUT_MS = 25000;
  var SUGGEST_MS = 450;
  var FIRST_BATCH = 6; // publications affichées au premier chargement
  var MORE_BATCH = 3; // publications ajoutées à chaque « Charger plus »

  // Espaces simples : la supply lit ces textes tels quels (pas d'espace fine insécable).
  function fmt(n) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function compact(n) {
    if (n == null) return '';
    if (n >= 1e6) return (n / 1e6).toFixed(n >= 1e7 ? 0 : 1).replace('.0', '') + 'M';
    if (n >= 1e3) return (n / 1e3).toFixed(n >= 1e4 ? 0 : 1).replace('.0', '') + 'k';
    return String(n);
  }

  function tpl(str, vars) {
    return String(str || '').replace(/\[(\w+)\]/g, function (_, k) {
      return vars[k] != null ? vars[k] : '';
    });
  }

  function cleanHandle(raw) {
    var v = String(raw || '').trim();
    var fromUrl = v.match(/(?:tiktok\.com|instagram\.com)\/@?([^/?#\s]+)/i);
    if (fromUrl) v = fromUrl[1];
    return v.replace(/\s+/g, '').replace(/^@+/, '').toLowerCase();
  }

  // Parts égales, le reste sur la première vidéo. split(1000, 3) → [334, 333, 333].
  function split(total, n) {
    var base = Math.floor(total / n);
    var out = [];
    for (var i = 0; i < n; i++) out.push(base);
    out[0] += total - base * n;
    return out;
  }

  // Icônes des statistiques (SVG en trait, couleur héritée). Chaînes fixes, sans donnée externe.
  var ICONS = {
    views: '<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
    likes: '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/>',
    shares: '<path d="M14 5l7 7-7 7"/><path d="M21 12H10a7 7 0 0 0-7 7"/>',
    saves: '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>'
  };
  // Une statistique : icône + valeur.
  function stat(key, text) {
    var s = el('span', 'pv-stat');
    var i = el('span', 'pv-stat__ico');
    i.setAttribute('aria-hidden', 'true');
    i.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + ICONS[key] + '</svg>';
    s.appendChild(i);
    s.appendChild(document.createTextNode(text));
    return s;
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function init(root) {
    if (root.dataset.packInit === '1') return;
    root.dataset.packInit = '1';

    var data;
    try {
      data = JSON.parse(root.querySelector('[data-pack-data]').textContent);
    } catch (e) {
      return;
    }
    // Le filtre Liquid t échappe le HTML (l'apostrophe devient &#39;) : on décode.
    var t = {};
    var decoder = document.createElement('textarea');
    Object.keys(data.i18n || {}).forEach(function (k) {
      decoder.innerHTML = data.i18n[k];
      t[k] = decoder.value;
    });
    var variants = {};
    data.variants.forEach(function (v) { variants[String(v.id)] = v; });

    var productForm = root.querySelector('[data-pack-product-form]');
    var variantInput = root.querySelector('[data-pack-variant-input]');
    var planInput = root.querySelector('[data-pack-plan-input]');
    var propsWrap = root.querySelector('[data-pack-properties]');
    var submit = root.querySelector('[data-pack-submit]');
    var submitText = submit.querySelector('span');
    var why = root.querySelector('[data-pack-why]');
    var express = root.querySelector('[data-pack-express]');
    var userInput = root.querySelector('[data-pack-username]');
    var fieldEl = root.querySelector('[data-pack-field]');
    // Plus de bouton « Rechercher » : on choisit un profil dans la liste, ou Entrée.
    var searchBtn = root.querySelector('[data-pack-search]') || document.createElement('button');
    var statusEl = root.querySelector('[data-pack-status]');
    var profileEl = root.querySelector('[data-pack-profile]');
    var hintEl = root.querySelector('[data-pack-pick-hint]');
    var grid = root.querySelector('[data-pack-grid]');
    var recap = root.querySelector('[data-pack-recap]');
    var recapList = root.querySelector('[data-pack-recap-list]');

    var state = {
      variantId: String(variantInput.value),
      freq: '',
      handle: '',
      profile: null,
      videos: [],
      selected: [], // ids, dans l'ordre de sélection : la première reçoit le reste
      next: null, // curseur de la page suivante de publications
      buffer: [], // publications reçues mais pas encore affichées
      suggestReq: 0,
      reqId: 0
    };

    root.querySelectorAll('.pv-num').forEach(function (n) {
      n.textContent = fmt(parseInt(n.textContent, 10) || 0);
    });

    function variant() { return variants[state.variantId]; }
    function planId() { return state.freq === 'week' ? data.planWeek : state.freq === 'month' ? data.planMonth : ''; }

    // ---------------------------------------------------------------- Offres
    var offers = root.querySelectorAll('[data-pack-offer]');

    function selectOffer(card) {
      var id = card.getAttribute('data-variant-id');
      // L'offre choisie reste ouverte : son contenu est toujours visible.
      offers.forEach(function (o) {
        var on = o === card;
        o.classList.toggle('is-active', on);
        o.classList.toggle('is-open', on);
        var head = o.querySelector('.pv-offer__head');
        head.setAttribute('aria-checked', on ? 'true' : 'false');
        head.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      if (id === state.variantId) return;
      state.variantId = id;
      variantInput.value = id;

      // Sélection trop longue pour le nouveau pack : on garde les premières.
      var max = variant().maxPosts;
      if (state.selected.length > max) {
        state.selected = state.selected.slice(0, max);
        flash(tpl(t.trimmed, { max: max }));
      }
      if (!state.freq) applyDefaultFreq();
      render();
    }

    offers.forEach(function (card) {
      card.querySelector('.pv-offer__head').addEventListener('click', function () { selectOffer(card); });
    });

    // ------------------------------------------------------------- Fréquence
    var freqBtns = root.querySelectorAll('[data-pack-freq]');

    function setFreq(f) {
      state.freq = f;
      freqBtns.forEach(function (b) {
        var on = b.getAttribute('data-pack-freq') === f;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      render();
    }

    function applyDefaultFreq() {
      var f = data.defaultFreq === 'month' ? 'month' : 'week';
      if (f === 'week' && !data.planWeek) f = 'month';
      if (f === 'month' && !data.planMonth) f = 'week';
      if ((f === 'week' && data.planWeek) || (f === 'month' && data.planMonth)) setFreq(f);
    }

    freqBtns.forEach(function (b) {
      b.addEventListener('click', function () { setFreq(b.getAttribute('data-pack-freq')); });
    });

    // --------------------------------------------------------- Compte / vidéos
    function setStatus(msg, kind) {
      statusEl.hidden = !msg;
      statusEl.textContent = msg || '';
      statusEl.className = 'pv-msg' + (kind ? ' pv-msg--' + kind : '');
    }

    // Bouton « Charger plus », placé sous la grille.
    var moreBtn = el('button', 'pv-more', t.loadMore);
    moreBtn.type = 'button';
    moreBtn.hidden = true;
    grid.parentNode.insertBefore(moreBtn, grid.nextSibling);

    function resetAccount() {
      state.profile = null;
      state.videos = [];
      state.selected = [];
      state.next = null;
      state.buffer = [];
      profileEl.hidden = true;
      profileEl.textContent = '';
      grid.textContent = '';
      moreBtn.hidden = true;
      hintEl.hidden = true;
    }

    // Tuiles grises animées pendant le chargement : la grille apparaît tout de suite.
    function skeletons(n) {
      for (var i = 0; i < n; i++) grid.appendChild(el('span', 'pv-tile pv-tile--skeleton'));
    }
    function clearSkeletons() {
      grid.querySelectorAll('.pv-tile--skeleton').forEach(function (s) { s.remove(); });
    }

    function request(handle, cursor) {
      var url = data.api + '?platform=' + encodeURIComponent(data.platform) + '&username=' + encodeURIComponent(handle) +
        (cursor ? '&cursor=' + encodeURIComponent(cursor) : '');
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, REQUEST_TIMEOUT_MS);
      return fetch(url, { signal: ctrl ? ctrl.signal : undefined, credentials: 'omit' })
        .then(function (r) { return r.json().catch(function () { return { status: 'server_error' }; }); })
        .catch(function () { return { status: 'server_error' }; })
        .then(function (res) { clearTimeout(timer); return res || {}; });
    }

    function search() {
      clearTimeout(suggestTimer);
      state.suggestReq++;
      hideSuggest();
      var handle = cleanHandle(userInput.value);
      userInput.value = handle;
      if (!HANDLE_RE.test(handle)) {
        resetAccount();
        state.handle = '';
        setStatus(t.invalid, 'error');
        render();
        return;
      }
      if (handle === state.handle) return; // déjà affiché ou en cours

      resetAccount();
      state.handle = handle;
      var reqId = ++state.reqId;
      setStatus(t.loading, 'loading');
      searchBtn.disabled = true;
      skeletons(FIRST_BATCH);
      render();

      request(handle, '').then(function (res) {
        if (reqId !== state.reqId) return; // une recherche plus récente a pris le relais
        searchBtn.disabled = false;
        clearSkeletons();
        handleResult(res);
      });
    }

    function handleResult(res) {
      var s = res.status;
      if (res.profile) renderProfile(res.profile);
      if (s === 'success' && Array.isArray(res.videos) && res.videos.length) {
        state.profile = res.profile || { username: state.handle };
        setStatus('', '');
        addVideos(res.videos, res.next, FIRST_BATCH);
      } else {
        // Échec : on autorise à relancer la même recherche.
        state.handle = '';
        var msg = {
          not_found: t.notFound,
          private_account: t.private,
          no_videos: t.noVideos,
          invalid_username: t.invalid,
          rate_limit: t.rateLimit
        }[s] || t.server;
        setStatus(msg, 'error');
      }
      render();
    }

    function loadMore() {
      if (moreBtn.disabled) return;
      // Assez de publications en réserve : affichage immédiat, sans appel.
      if (state.buffer.length >= MORE_BATCH || (state.buffer.length && !state.next)) {
        reveal(MORE_BATCH);
        render();
        return;
      }
      if (!state.next) return;
      var reqId = state.reqId;
      moreBtn.disabled = true;
      moreBtn.textContent = t.loading;
      skeletons(MORE_BATCH);
      request(state.handle, state.next).then(function (res) {
        if (reqId !== state.reqId) return;
        clearSkeletons();
        moreBtn.disabled = false;
        moreBtn.textContent = t.loadMore;
        if (res.status === 'success' && Array.isArray(res.videos)) {
          addVideos(res.videos, res.next, MORE_BATCH);
          render();
        } else {
          flash(t.server);
        }
      });
    }
    moreBtn.addEventListener('click', loadMore);

    function renderProfile(p) {
      profileEl.textContent = '';
      if (p.avatar) {
        var img = el('img', 'pv-profile__avatar');
        img.src = p.avatar;
        img.alt = '';
        img.loading = 'lazy';
        img.referrerPolicy = 'no-referrer';
        img.onerror = function () { img.remove(); };
        profileEl.appendChild(img);
      }
      var txt = el('span', 'pv-profile__txt');
      if (p.nickname) txt.appendChild(el('strong', null, p.nickname));
      txt.appendChild(el('span', null, '@' + (p.username || state.handle)));
      profileEl.appendChild(txt);
      profileEl.hidden = false;
    }

    // Met une page de publications en réserve (sans doublon), puis en affiche n.
    function addVideos(list, next, n) {
      var known = {};
      state.videos.concat(state.buffer).forEach(function (v) { known[v.id] = true; });
      list.forEach(function (v) {
        if (known[v.id]) return;
        known[v.id] = true;
        state.buffer.push(v);
      });
      state.next = next || null;
      reveal(n);
    }

    // Affiche n publications de la réserve.
    function reveal(n) {
      var batch = state.buffer.splice(0, n);
      batch.forEach(function (v) {
        state.videos.push(v);
        grid.appendChild(tileFor(v));
      });
      moreBtn.hidden = !state.buffer.length && !state.next;
    }

    // Miniature refusée par le CDN : on retire la tuile et on la remplace.
    function dropBroken(id, tile) {
      if (state.selected.indexOf(id) >= 0) return; // déjà choisie : on la garde
      state.videos = state.videos.filter(function (v) { return v.id !== id; });
      tile.remove();
      if (state.buffer.length) reveal(1);
      else moreBtn.hidden = !state.next;
    }

    function tileFor(v) {
      var b = el('button', 'pv-tile');
      b.type = 'button';
      b.setAttribute('data-id', v.id);
      b.setAttribute('aria-pressed', 'false');

      var img = el('img', 'pv-tile__img');
      img.src = v.thumbnail;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.referrerPolicy = 'no-referrer';
      img.onerror = function () { dropBroken(v.id, b); };
      b.appendChild(img);

      if (v.type === 'image' || v.type === 'carousel') {
        b.appendChild(el('span', 'pv-tile__type', v.type === 'image' ? t.photo : t.carousel));
      }
      var stats = el('span', 'pv-tile__stats');
      if (v.views != null) stats.appendChild(stat('views', compact(v.views)));
      if (v.likes != null) stats.appendChild(stat('likes', compact(v.likes)));
      b.appendChild(stats);
      if (v.date) {
        try {
          var d = new Date(v.date);
          b.appendChild(el('span', 'pv-tile__date', d.toLocaleDateString(document.documentElement.lang || undefined, { day: 'numeric', month: 'short' })));
        } catch (e) {}
      }
      b.appendChild(el('span', 'pv-tile__badge'));
      b.addEventListener('click', function () { toggleVideo(v.id, b); });
      return b;
    }

    function toggleVideo(id, tile) {
      var i = state.selected.indexOf(id);
      if (i >= 0) {
        state.selected.splice(i, 1);
      } else {
        var max = variant().maxPosts;
        if (max === 1) {
          state.selected = [id]; // pack à une publication : on remplace directement
        } else if (state.selected.length >= max) {
          flash(tpl(t.maxReached, { max: max }));
          tile.classList.remove('is-shake');
          void tile.offsetWidth;
          tile.classList.add('is-shake');
          return;
        } else {
          state.selected.push(id);
        }
      }
      render();
    }

    var flashTimer = null;
    function flash(msg) {
      hintEl.hidden = false;
      hintEl.textContent = msg;
      hintEl.classList.add('is-flash');
      clearTimeout(flashTimer);
      flashTimer = setTimeout(function () {
        hintEl.classList.remove('is-flash');
        renderHint();
      }, 2600);
    }

    function renderHint() {
      if (!state.videos.length) { hintEl.hidden = true; return; }
      var max = variant().maxPosts;
      hintEl.hidden = false;
      hintEl.textContent = tpl(t.pickHint, { count: state.selected.length, max: max });
    }

    // Suggestions de profils pendant la frappe, même rendu que Pack TK
    // (classes al-results de account-lookup.css) : le client choisit le bon
    // compte, puis ses publications s'affichent.
    var MAX_SUGGEST = data.platform === 'instagram' ? 2 : 3;
    var AVATAR_PLACEHOLDER = 'data:image/svg+xml,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><rect width="40" height="40" fill="#E7ECF8"/>' +
      '<circle cx="20" cy="16" r="7" fill="#AEBBDA"/><path d="M6 36c2-8 8-11 14-11s12 3 14 11z" fill="#AEBBDA"/></svg>'
    );
    var VERIFIED_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="12" r="11" fill="#1B4DFF"/>' +
      '<path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var suggest = el('ul', 'al-results pv-suggest');
    suggest.setAttribute('role', 'listbox');
    suggest.hidden = true;
    fieldEl.parentNode.insertBefore(suggest, fieldEl.nextSibling);
    var suggestTimer = null;
    var spin = el('span', 'pv-field__spin');
    spin.setAttribute('aria-hidden', 'true');
    fieldEl.appendChild(spin);

    function setSearching(on) {
      fieldEl.classList.toggle('is-searching', on);
    }

    function hideSuggest() {
      setSearching(false);
      suggest.hidden = true;
      suggest.textContent = '';
    }

    // Lignes grises animées le temps de la recherche.
    function suggestSkeleton() {
      suggest.textContent = '';
      for (var i = 0; i < MAX_SUGGEST; i++) {
        var li = el('li', 'pv-suggest__skeleton');
        li.setAttribute('aria-hidden', 'true');
        li.appendChild(el('span', 'pv-sk pv-sk--avatar'));
        var lines = el('span', 'pv-sk__lines');
        lines.appendChild(el('span', 'pv-sk pv-sk--line'));
        lines.appendChild(el('span', 'pv-sk pv-sk--line pv-sk--short'));
        li.appendChild(lines);
        suggest.appendChild(li);
      }
      suggest.hidden = false;
    }

    function fetchSuggest(keyword) {
      var reqId = ++state.suggestReq;
      var url = data.api + '?platform=' + encodeURIComponent(data.platform) + '&search=' + encodeURIComponent(keyword);
      fetch(url, { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; })
        .then(function (res) {
          // Réponse périmée ou compte déjà choisi : on n'affiche rien.
          if (reqId !== state.suggestReq || state.handle) return;
          setSearching(false);
          // En cas d'échec de la recherche, le pseudo tapé reste proposé.
          renderSuggest(keyword, res && res.status === 'success' ? res.users || [] : []);
        });
    }

    function renderSuggest(typed, users) {
      suggest.textContent = '';
      var list = [];
      var hasTyped = false;
      users.forEach(function (u) {
        if (!u || !u.uniqueId) return;
        if (cleanHandle(u.uniqueId) === typed) hasTyped = true;
        list.push(u);
      });
      // Le pseudo tapé reste toujours sélectionnable, même absent des résultats.
      if (!hasTyped) list.unshift({ uniqueId: typed, typed: true });
      list.slice(0, MAX_SUGGEST).forEach(function (u) {
        var li = el('li');
        li.setAttribute('role', 'none');
        var btn = el('button', 'al-results__option');
        btn.type = 'button';
        btn.setAttribute('role', 'option');

        var img = el('img', 'al-results__avatar');
        img.alt = '';
        img.referrerPolicy = 'no-referrer';
        img.onerror = function () { img.onerror = null; img.src = AVATAR_PLACEHOLDER; };
        img.src = u.avatar || AVATAR_PLACEHOLDER;
        btn.appendChild(img);

        var meta = el('span', 'al-results__meta');
        var handle = el('span', 'al-results__handle', '@' + u.uniqueId);
        if (u.verified) {
          var badge = el('span', 'al-badge');
          badge.innerHTML = VERIFIED_SVG;
          handle.appendChild(badge);
        }
        meta.appendChild(handle);
        var parts = [];
        if (u.typed) parts.push(t.useThis);
        else {
          if (u.nickname) parts.push(u.nickname);
          if (u.followerCount != null) parts.push(compact(u.followerCount) + ' ' + t.followers);
        }
        meta.appendChild(el('span', 'al-results__sub', parts.join(' · ')));
        btn.appendChild(meta);

        // mousedown : passe avant le blur du champ.
        btn.addEventListener('mousedown', function (e) { e.preventDefault(); });
        btn.addEventListener('click', function () {
          userInput.value = u.uniqueId;
          hideSuggest();
          search();
        });
        li.appendChild(btn);
        suggest.appendChild(li);
      });
      suggest.hidden = false;
    }

    searchBtn.addEventListener('click', function () { hideSuggest(); search(); });
    userInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); hideSuggest(); search(); }
      if (e.key === 'Escape') hideSuggest();
      if (e.key === 'ArrowDown' && !suggest.hidden) { e.preventDefault(); suggest.querySelector('button').focus(); }
    });
    userInput.addEventListener('input', function () {
      var handle = cleanHandle(userInput.value);
      // Le compte change : l'ancienne sélection ne vaut plus.
      if (state.handle && handle !== state.handle) {
        state.reqId++;
        state.handle = '';
        searchBtn.disabled = false;
        resetAccount();
        setStatus('', '');
        render();
      }
      clearTimeout(suggestTimer);
      state.suggestReq++;
      if (HANDLE_RE.test(handle) && handle.length >= 2) {
        setSearching(true);
        suggestSkeleton();
        suggestTimer = setTimeout(function () { fetchSuggest(handle); }, SUGGEST_MS);
      } else {
        hideSuggest();
      }
    });
    document.addEventListener('click', function (e) {
      if (!suggest.contains(e.target) && e.target !== userInput) hideSuggest();
    });

    // ---------------------------------------------------- Répartition / rendu
    function allocation() {
      var v = variant();
      var n = state.selected.length;
      if (!v || !n) return [];
      var parts = {};
      STATS.forEach(function (s) { parts[s.key] = split(v[s.key] || 0, n); });
      return state.selected.map(function (id, i) {
        var video = state.videos.filter(function (x) { return x.id === id; })[0] || {};
        var row = { id: id, url: video.url || '', thumbnail: video.thumbnail || '' };
        STATS.forEach(function (s) { row[s.key] = parts[s.key][i]; });
        return row;
      });
    }

    function line(row) {
      return STATS.map(function (s) { return fmt(row[s.key]) + ' ' + s.label; }).join(' | ');
    }

    function addProp(name, value) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'properties[' + name + ']';
      i.value = value;
      propsWrap.appendChild(i);
    }

    function render() {
      var v = variant();
      var rows = allocation();

      // Tuiles : état sélectionné + numéro d'ordre
      grid.querySelectorAll('.pv-tile[data-id]').forEach(function (tile) {
        var idx = state.selected.indexOf(tile.getAttribute('data-id'));
        tile.classList.toggle('is-selected', idx >= 0);
        tile.setAttribute('aria-pressed', idx >= 0 ? 'true' : 'false');
        tile.querySelector('.pv-tile__badge').textContent = idx >= 0 ? String(idx + 1) : '';
      });
      if (!hintEl.classList.contains('is-flash')) renderHint();

      // Prix facturé en abonnement sur chaque offre (fréquence choisie, sinon
      // la première disponible), prix normal barré s'il diffère.
      var shownPlan = planId() || data.planWeek || data.planMonth;
      offers.forEach(function (card) {
        var cv = variants[card.getAttribute('data-variant-id')];
        var priceEl = card.querySelector('[data-pack-offer-price]');
        if (!cv || !priceEl) return;
        var sub = shownPlan && cv.prices[shownPlan];
        priceEl.textContent = '';
        priceEl.appendChild(document.createTextNode(sub || cv.price));
        if (sub && sub !== cv.price) priceEl.appendChild(el('s', 'pv-offer__was', cv.price));
      });

      // Prix par fréquence pour le pack choisi
      ['week', 'month'].forEach(function (f) {
        var p = root.querySelector('[data-pack-freq-price="' + f + '"]');
        var pid = f === 'week' ? data.planWeek : data.planMonth;
        if (p && v && pid && v.prices[pid]) p.textContent = v.prices[pid] + ' ' + (f === 'week' ? t.perWeek : t.perMonth);
      });

      // Récapitulatif
      recapList.textContent = '';
      rows.forEach(function (row, i) {
        var li = el('li', 'pv-recap__row');
        if (row.thumbnail) {
          var img = el('img', 'pv-recap__thumb');
          img.src = row.thumbnail;
          img.alt = '';
          img.referrerPolicy = 'no-referrer';
          li.appendChild(img);
        }
        var body = el('div', 'pv-recap__body');
        body.appendChild(el('strong', null, tpl(t.videoN, { n: i + 1 })));
        var q = el('span', 'pv-recap__stats');
        q.appendChild(stat('views', fmt(row.views)));
        q.appendChild(stat('likes', fmt(row.likes)));
        q.appendChild(stat('shares', fmt(row.shares)));
        q.appendChild(stat('saves', fmt(row.saves)));
        body.appendChild(q);
        li.appendChild(body);
        recapList.appendChild(li);
      });
      recap.hidden = rows.length === 0;

      // Propriétés de commande
      propsWrap.textContent = '';
      planInput.value = planId();
      if (state.profile && rows.length) {
        addProp('Plateforme', data.platform === 'instagram' ? 'Instagram' : 'TikTok');
        addProp("Nom d'utilisateur", '@' + (state.profile.username || state.handle));
        rows.forEach(function (row, i) {
          addProp('Vidéo ' + (i + 1), row.url + ' | ' + line(row));
        });
        addProp('_Total pack', v.title + ' | ' + line(v));
      }

      // Bouton
      var missing = !state.profile ? t.needUser : !rows.length ? t.needVideo : '';
      var ready = !missing && !!planInput.value && v && v.available;
      submit.disabled = !ready;
      if (express) {
        express.classList.toggle('is-locked', !ready);
        express.setAttribute('aria-disabled', ready ? 'false' : 'true');
      }
      submit.setAttribute('aria-disabled', ready ? 'false' : 'true');
      why.textContent = ready ? '' : missing;
      why.hidden = ready || !missing;
      var price = v && planInput.value ? v.prices[planInput.value] : '';
      submitText.textContent = ready && price
        ? tpl(t.ctaReady, { price: price, period: state.freq === 'month' ? t.perMonth : t.perWeek })
        : t.ctaIdle;
    }

    // Garde : rien ne part sans compte, vidéo(s) et fréquence (même via la touche Entrée).
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        if (submit.disabled || !planInput.value || !propsWrap.children.length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          render();
        }
      }, true);
    }
    // Paiement rapide : bloqué (clic intercepté avant Shopify) tant que la commande
    // est incomplète ; on amène le client à ce qui manque.
    if (express) {
      express.addEventListener('click', function (e) {
        if (!express.classList.contains('is-locked')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        render();
        if (!state.profile) userInput.focus();
        else grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
    }

    // product-form.js retire aria-disabled après l'ajout : on réapplique notre état.
    new MutationObserver(function () {
      if (submit.getAttribute('aria-disabled') == null) render();
    }).observe(submit, { attributes: true, attributeFilter: ['aria-disabled'] });

    applyDefaultFreq();
    render();
  }

  function boot() {
    document.querySelectorAll('[data-pack]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
